export const url_dev = process.env.REACT_APP_API_DEV_URL;
export const url_certificate =
  "https://rl412zstdi.execute-api.us-east-2.amazonaws.com/dev";